<template>
	<div class="item-adres">
		<div class="item-adres-br">
		    <h3>Order Summary</h3>
			<ul>
				<li><strong>Products</strong><span><var>{{ productCount }}</var></span></li>
				<li v-if="percentOffName && percentSavings > 0 && membership >= 1" class="text--blue" style="font-weight:bold"><strong class="memberSavings" style="font-weight:bold">{{ percentOffName }}</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="minusCurrencySymbolLeft"><var>{{ percentSavings }}</var></span></li>
                                <li v-if="percentOffName && percentRetailSavings > 0 && !membership" class="text--blue" style="font-weight:bold"><strong class="memberSavings" style="font-weight:bold">{{ percentOffName }}</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="minusCurrencySymbolLeft"><var>{{ percentRetailSavings }}</var></span></li>
				<li v-if="percentOffNameSecond && percentSavingsSecond > 0"><strong>{{ percentOffNameSecond }}</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>-{{ percentSavingsSecond }}</var></span></li>
            <li v-if="couponAmount>0 && shippingOrderCount > 0" class="text--blue" style="font-weight:bold"><strong class="memberSavings" style="font-weight:bold">${{ couponAmount }} Off from<br>{{ enrollerFirst }}</strong> 
             <span>-<var :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ couponAmount }}</var></span>
            </li>
				<li v-if="retailTotalPrice > 0">
               <strong v-if="retailOnly!=1">Retail Price</strong>
               <strong v-else>Price</strong>
               <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">
                  <var v-if="membership>=1" style="text-decoration:line-through">{{ retailTotalPrice }}</var>
                  <var v-else>{{ retailTotalPrice }}</var>
               </span>
            </li>            
            <li v-if="totalMemberSave > 0 && membership >= 1 && !autoship" class="text--orange"><strong  class="memberSavings">You Save</strong><span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ totalMemberSave }}</var></span></li>
            <li v-if="totalAutoSave > 0 && membership >= 1 && autoship" class="text--orange"><strong  class="memberSavings">You Save</strong><span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ totalAutoSave }}</var></span></li>
            <li v-if="membership >= 1 && !autoship" class="text--blue"><strong>Member Price</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ totalPrice }}</var></span></li>
            <li v-if="membership >= 1 && autoship" class="text--blue"><strong>Subscribe & Save Price</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ autoTotalPrice }}</var></span></li>
                        </ul>
                        <ul>
                         <li v-if="totalMemberSave > 0 && !membership && retailOnly!=1" class="cart-summary-add-membership-li"> 
                            <a class="cart-summary-add-membership" href=# @click="addMembershipToCart">
                            Last Chance to Save <b :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ totalMemberSave }}</var></b> on this Order
                            </a>
                         </li>
			</ul>
		</div>
	</div>
</template>

<style>
	.item-adres span[data-currency-symbol-left], .itembar span[data-currency-symbol-right] {
		float: right !important;
	}
   .cart-summary-notice {
      font-family: "Lato","Helvetica Neue","Helvetica",Helvetica,Arial,sans-serif;
      color:red;
      font-size:12px;
      margin-bottom:10px; 
   }
</style>

<script>
    export default {
        props: {
	 totalPrice: String,
	 retailTotalPrice: String,
         autoTotalPrice: String,
         currencySymbolRight: String,
         currencySymbolLeft: String,
         minusCurrencySymbolLeft: String,
	 productCount: Number,
         productFreeCount: Number,
         totalMemberSave: String,
         totalAutoSave: String,
	 isLoggedIn: Boolean,
	 percentSavings: String,
         percentRetailSavings: String,
	 percentOffName: String,
	 percentSavingsSecond: String,
	 percentOffNameSecond: String,
         membership: Number,
         scriptName: String,
         coupon: Number,
         couponAmount: String,
         enrollerFirst: String,
         shippingOrderCount: Number,
         retailOnly:Number,
         autoship: Boolean,
		},
        components: {
                },
        data: function () {
                        return {
                        }
                },
        methods: {
           addMembershipToCart () {
              shoppingCart.addToCart(1,1).then((x) => {
                  document.getElementById("openCart").click()
               })
            },
        }
    }

</script>

<style>
</style>
